module.exports = __webpack_public_path__ + "media/images/85/sleep_paralysis_night_mare-99def4c67aa174dd6f8c78bc3c841530.jpg";